export default "__VITE_ASSET__DSXvlWqD__"